import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Box, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { LenderFieldMap, PortalConfiguration } from '@trnsact/trnsact-shared-types';
import {
  formatDCRProperty,
  getTrnsactDisplayName,
  getTrnsactDisplayValue,
} from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/lib';

interface Props {
  field: LenderFieldMap;
  portalConfiguration: PortalConfiguration;
}

export const TrnsactInput = ({ field, portalConfiguration }: Props) => {
  const classes = useStyles();

  const dcrProperties = formatDCRProperty(field.details?.dcrPropertySource);
  const trnsactDisplayName = getTrnsactDisplayName(field, portalConfiguration);
  const trnsactDisplayValue = getTrnsactDisplayValue(field);

  return (dcrProperties?.length ?? 0) > 0 ? (
    <Box>
      <TextField
        disabled
        fullWidth
        size="small"
        variant="outlined"
        defaultValue={trnsactDisplayValue}
        label={dcrProperties![0] || trnsactDisplayName}
        required={field.details?.required === 'REQUIRED'}
        helperText={dcrProperties!.length > 1 ? `Alt Source: ${dcrProperties!.slice(1).join(' OR ')}` : ''}
      />
    </Box>
  ) : (
    <Box className={classes.notMappedContainer}>
      <Typography variant="subtitle2" component="span" color="#939393">
        Not Mapped
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  notMappedContainer: {
    padding: '8px 24px',
    backgroundColor: grey.A200,
    borderRadius: '2px',
    textAlign: 'center',
  },
}));
